module.exports = __webpack_public_path__ + "resources/img/img_coolfilter2.abceb3f8f3b133e6baa40539688975ed.png";